// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a6aa8aab","223":"11cd2d30","453":"1cb735c8","455":"4a0123c8"}[chunkId] + ".chunk.js";
};